"use client";

import Link from "next/link";
import { Typography } from "@mui/material";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import type { BlocksContent } from "@strapi/blocks-react-renderer";

interface StrapiBlocksProps {
  content: BlocksContent;
}

//https://github.com/strapi/blocks-react-renderer
function StrapiBlocks({ content }: StrapiBlocksProps) {
  return (
    <BlocksRenderer
      content={content}
      blocks={{
        paragraph: ({ children }) => {
          if (!children) {
            return <br />;
          }
          return <Typography variant="body1">{children}</Typography>;
        },
        heading: ({ children, level }) => {
          switch (level) {
            case 1:
              return <Typography variant="h1">{children}</Typography>;
            case 2:
              return <Typography variant="h2">{children}</Typography>;
            case 3:
              return <Typography variant="h3">{children}</Typography>;
            case 4:
              return <Typography variant="h4">{children}</Typography>;
            case 5:
              return <Typography variant="h5">{children}</Typography>;
            case 6:
              return <Typography variant="h6">{children}</Typography>;
            default:
              return <Typography variant="h1">{children}</Typography>;
          }
        },
        link: ({ children, url }) => <Link href={url}>{children}</Link>,
      }}
      modifiers={{
        bold: ({ children }) => <strong>{children}</strong>,
        italic: ({ children }) => <span className="italic">{children}</span>,
      }}
    />
  );
}

export default StrapiBlocks;
